module.exports = __webpack_public_path__ + "static/4-months-938c2f07f63b26b9b5eaa5235366874e.png";